






































import VueOptions from '@utils/VueOptions'
import BoxChart from '@ui/Dashboard/Charts/BoxChart'
import CoolGallery from './CoolGallery'

settings =
  name: 'RecapsPhotosGallery'

  vue:
    props: ['photos', 'options']

    components: {
      BoxChart,
      CoolGallery,
    }

    data: ->
      selectedKey: null

    computed:
      opt: ->
        @options || {}

      boxStyle: ->
        @opt.boxStyle

      galleries: ->
        [
          {
            key: 'published_photos'
            label: 'Activation'
            photos: @photos?.published_photos || []
          }
          {
            key: 'omnichannel_photos'
            label: 'Omnichannel'
            photos: @photos?.omnichannel_photos || []
          }
        ].filter(({ photos }) => photos.length > 0)

      selectedPhotos: ->
        @galleries.find(({ key }) => key is @selectedKey)?.photos || []

    watch:
      galleries: (galleries) ->
        @selectedKey = galleries[0]?.key

export default VueOptions.vue settings
